
import ColorSwatch from "../../../assets/duotone/ColorSwatch.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ColorSwatchIcon({ className, dataTestid = "ColorSwatchIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ColorSwatch data-testid={dataTestid} className={classes} {...rest} />
  );
}
